import { HeatmapSymbologyConfig, RadiusUnit } from '../../../../types/symbology.types';
import { COLOR_RAMPS } from '../constants';

// US-101677 Scenario 5 / 9 — validation messages (exact AC wording).
export const OPACITY_ERROR = 'Opacity must be a whole number between 0 and 100';
export const ZOOM_ERROR = 'Minimum zoom must be less than maximum zoom';

// US-101677 Scenario 7: supported radius units.
export const RADIUS_UNITS: { value: RadiusUnit; label: string }[] = [
  { value: 'miles', label: 'Miles' },
  { value: 'kilometers', label: 'Kilometers' },
  { value: 'meters', label: 'Meters' },
  { value: 'pixels', label: 'Pixels' },
];

// Scenario 8: zoom values limited to the map's configured zoom range.
export const ZOOM_MIN = 0;
export const ZOOM_MAX = 22;
export const ZOOM_OPTIONS = Array.from({ length: ZOOM_MAX - ZOOM_MIN + 1 }, (_, i) => ZOOM_MIN + i);

export const isValidOpacity = (v: unknown): boolean => typeof v === 'number' && Number.isInteger(v) && v >= 0 && v <= 100;

export const isValidGroupRadius = (v: unknown): boolean => typeof v === 'number' && Number.isInteger(v) && v >= 0;

export const defaultHeatmapConfig = (): HeatmapSymbologyConfig => ({
  type: 'heatmap',
  colorRamp: COLOR_RAMPS[0],
  opacity: 100,
  groupRadius: 1,
  radiusUnit: 'kilometers',
  minZoom: ZOOM_MIN,
  maxZoom: ZOOM_MAX,
  weightAttribute: null,
});

/**
 * Save-time validation (US-101677 Scenarios 5 & 9). Returns the first AC error
 * string, or null when the config is valid.
 */
export const validateHeatmapConfig = (config: HeatmapSymbologyConfig): string | null => {
  if (!isValidOpacity(config.opacity)) return OPACITY_ERROR;
  // Scenario 9: min must be strictly less than max.
  if (config.minZoom >= config.maxZoom) return ZOOM_ERROR;
  return null;
};
